import {
  GET_ANOMALIES_VOLVO,
  GET_ANOMALIES_VOLVO_ERROR,
  GET_ANOMALIES_VOLVO_SUCCESS,
} from './Anomalies.actions';

const initialState = {
  data: [],
  geofenceAnomalies: [],
  loading: false,
  error: undefined,
};

/**
 * The Anomalies Volvo Reducer.
 */
const anomaliesVolvoReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ANOMALIES_VOLVO: {
      return { ...state, loading: true, error: undefined }; // Set loading to true
    }
    case GET_ANOMALIES_VOLVO_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Set error and loading to false
    }
    case GET_ANOMALIES_VOLVO_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data, // Save the data to the state
        geofenceAnomalies: payload.geofenceAnomalies,
      };
    }
    default: {
      return state; // Default case to return the unchanged state
    }
  }
};

export default anomaliesVolvoReducer;
